import React, { Fragment } from 'react';
export const makeLabelChild = (primary?: string, secondary?: string): JSX.Element => {
  return (
    <Fragment key={primary + (secondary ?? '')}>
      {primary}
      {secondary && <span>{secondary}</span>}
    </Fragment>
  );
};
